export const selectModalState = (state, modalName) => state.getIn(['modals', modalName]);
